module.exports = __webpack_public_path__ + "img/张建伟.b45c41b9.jpg";